import React from "react";
import Select from "react-select";
import { isEmpty } from "lodash";
import { FormControl } from "@chakra-ui/core";
import { errorMessages } from "../../../ErrorConfig/errorConfig";
import { pxToRem } from "../../../utils/dimensionConverter";

export const SelectText = ({ full, label, placeholder, errorValue, required, errorMessage, Option, dataSelector="data-test", ...otherProps }) => {
  const isInvalid = !!(errorValue);
  const hasvalue = isEmpty(otherProps.value);
  const { isDisabled } = otherProps;
  const customStyles = (isInvalid, hasvalue) => ({
    container: (props) => ({
      ...props,
      height: pxToRem(48),
      pointerEvents: "auto"
    }),
    control: (props) => ({
      ...props,
      backgroundColor: "#EFEEEF",
      borderRadius: pxToRem(12),
      height: pxToRem(44),
      fontSize: pxToRem(13),
      outline: "none",
      border: `2px solid ${isInvalid ? "#F26423" : "#EFEEEF"}`,
      boxShadow: "none",
      opacity: isDisabled ? 0.9 : 1,
      cursor: isDisabled ? "not-allowed" : "default",
      "&:hover": {
        border: "1px solid black",
        borderWidth: 2,
        backgroundColor: !isDisabled ? "#FFFFFF" : "#EFEEEF",
        borderColor: isInvalid && hasvalue ? "#F26423" : "#EFEEEF",
      },
      "&:focus": {
        borderColor: "red",
      },
    }),
    singleValue: (props) => ({
      ...props,
      color: isDisabled ? "#545454" : "#333333",
    }),
    indicatorSeparator: (props) => ({
      ...props,
      opacity: 0,
    }),
    dropdownIndicator: (props) => ({
      ...props,
      svg: {
        width: pxToRem(20),
        height: pxToRem(20),
      },
    }),
    loadingIndicator: (props) => ({
      ...props,
      fontSize: pxToRem(4),
    }),
    valueContainer: (props) => ({
      ...props,
      padding: `${pxToRem(2)} ${pxToRem(8)}`,
    }),
    option: (styles, { isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        fontSize: pxToRem(12),
        padding: `${pxToRem(12)} ${pxToRem(12)}`,
        backgroundColor: isDisabled
          ? null
          : isSelected
          ? "#EFEEEF"
          : isFocused
          ? "#EFEEEF"
          : null,
        color: isDisabled
          ? "#ccc"
          : isSelected
          ? false
            ? "white"
            : "black"
          : "#736973",
        cursor: isDisabled ? "not-allowed" : "pointer",
      };
    },
  });

  return (
    <div className={`form__group${full ? ' full' : ''}`}>
      <FormControl data-selector={dataSelector}>
        {label && <label htmlFor={otherProps['dataTestId']} className={`form__label ${required ? "field-required" : ""}`}>{label}</label>}
        <Select
          {...otherProps}
          components={ Option ? { Option } : {} }
          styles={customStyles(isInvalid, hasvalue)}
          placeholder={placeholder || ""}
          inputId={otherProps['dataTestId']}
        />
        {errorValue && <div className="form__error">
          <div className="form__error-message">
            {errorValue === 'required' ? errorMessages.requiredValueMissing : errorValue}
          </div>
        </div>}
      </FormControl>
    </div>
  );
};

export default SelectText;
